import React from 'react';
import { AlertTriangle } from 'lucide-react';

class CoverEditorErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, retryKey: 0 };
    this.retry = this.retry.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('CoverEditor error:', error, errorInfo);
  }

  retry() {
    this.setState(function(s) {
      return { hasError: false, error: null, retryKey: s.retryKey + 1 };
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="h-screen w-screen flex items-center justify-center bg-[#FAFAF9] px-6" data-testid="cover-editor-error">
          <div className="max-w-md text-center bg-white border border-[#D3D1C7] rounded-[12px] p-8 shadow-sm">
            <AlertTriangle className="w-9 h-9 text-[#BA7517] mx-auto" strokeWidth={1.4} />
            <h2 className="mt-4 text-2xl tracking-tight text-[#2C2C2A]" style={{ fontFamily: 'Georgia, serif', fontWeight: 500 }}>
              Something went wrong
            </h2>
            <p className="mt-2 text-sm text-[#6B6B68]">The cover editor encountered an unexpected error.</p>
            <button onClick={this.retry} className="mt-6 px-4 py-2 rounded-[8px] border border-[#D3D1C7] text-sm text-[#2C2C2A] hover:bg-[#F1EFE8]">
              Try again
            </button>
            <a href="/dashboard" data-testid="cover-editor-dashboard-link" className="inline-flex items-center gap-2 px-4 py-2 rounded-[8px] border border-[#D3D1C7] text-sm text-[#2C2C2A] hover:bg-[#F1EFE8]">
              Back to dashboard
            </a>
          </div>
        </div>
      );
    }
    return (
      React.createElement(React.Fragment, { key: this.state.retryKey }, this.props.children)
    );
  }
}

export default CoverEditorErrorBoundary;
